// ================= CART DRAWER TOGGLE =================
const cartDrawer = document.getElementById('cartDrawer');
const cartOverlay = document.getElementById('cartOverlay');

document.querySelectorAll('[data-cart-toggle]').forEach((el) => {
  el.addEventListener('click', () => {
    const isOpen = cartDrawer.classList.contains('open');
    if (isOpen) {
      cartDrawer.classList.remove('open');
      cartOverlay.classList.remove('open');
    } else {
      cartDrawer.classList.add('open');
      cartOverlay.classList.add('open');
    }
  });
});

// ================= ADD TO CART (Shopify AJAX API) =================
function moneyFormat(cents) {
  return '$' + (cents / 100).toFixed(2);
}

async function refreshCartDrawer() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  const cartCountEl = document.getElementById('cartCount');
  const cartItemsEl = document.getElementById('cartItems');
  const cartTotalEl = document.getElementById('cartTotal');

  cartCountEl.textContent = cart.item_count;
  cartCountEl.classList.remove('bump');
  void cartCountEl.offsetWidth;
  cartCountEl.classList.add('bump');

  if (cart.item_count === 0) {
    cartItemsEl.innerHTML = '<p class="cart-empty">Nothing in your box yet — go pick some cookies.</p>';
  } else {
    cartItemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-line">
        <div>
          <div class="cart-line__name">${item.product_title}</div>
          <div class="cart-line__meta">${item.quantity} × ${moneyFormat(item.price)}</div>
        </div>
        <div class="cart-line__meta">${moneyFormat(item.line_price)}</div>
      </div>
    `).join('');
  }

  cartTotalEl.textContent = moneyFormat(cart.total_price);
}

document.querySelectorAll('[data-product-form]').forEach((form) => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const button = form.querySelector('button[type="submit"]');
    const originalText = button.textContent;
    button.textContent = 'Adding…';
    button.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add to cart');
      }

      await refreshCartDrawer();
      cartDrawer.classList.add('open');
      cartOverlay.classList.add('open');
    } catch (err) {
      alert(err.message);
    } finally {
      button.textContent = originalText;
      button.disabled = false;
    }
  });
});

// Load the cart state on page load so the count is accurate
refreshCartDrawer();
